module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/banner_withpet-5ca1f679f76c075482fad3b0e3598cbd.webp";